import type LoggerService from 'garaje/services/logger';

export async function refreshApprovalChainAuditLogs(logger: LoggerService): Promise<void> {
  try {
    const { invalidateApprovalChainAuditLogs } = await import('reactRichComponents/visitors/ApprovalChainDetailsCard');
    invalidateApprovalChainAuditLogs();
  } catch (error) {
    logger.error('Failed to refresh approval chain audit logs', error as Error);
  }
}
